<template>
  <v-list class="py-0" v-if="role.name === 'Teacher'">
    <!-- Bảng thông tin chung -->
    <v-list-item active-class="primary white--text" link to="/teacher-dashboard">
      <v-list-item-icon class="mr-4">
        <v-icon>mdi-view-dashboard</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Bảng thông tin chung</v-list-item-title>
    </v-list-item>
    <!-- Quản lý công việc -->
    <TaskManager v-if="policies['task-manage-access']" />
    <!-- Giảng dạy -->
    <Teaching />
    <!-- Chủ nhiệm -->
    <OwnClass v-if="ownClassIds" />
    <!-- Học phí -->
    <!-- <TuitionFee v-if="policies['view-tuition-fee-group']" /> -->
    <!-- Sổ sách báo cáo -->
    <!-- <TeacherDocuments /> -->
    <DocDoc />
  </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import OwnClass from '@/components/basic/menu/teacher/OwnClass.vue'
import Teaching from '@/components/basic/menu/teacher/Teaching.vue'
// import TeacherDocuments from '@/components/basic/menu/teacher/TeacherDocuments.vue'
import TaskManager from '@/components/basic/menu/TaskManager'
// import TuitionFee from '@/components/basic/menu/TuitionFee'
import DocDoc from '@/components/basic/menu/DocDoc'

export default {
  components: {
    TaskManager,
    OwnClass,
    Teaching,
    // TeacherDocuments,
    // TuitionFee,
    DocDoc
  },
  computed: {
    ...mapState('auth', ['role', 'policies']),
    ...mapGetters('auth', ['ownClassIds']),
  },
}
</script>
